import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-plugin",
  templateUrl: "./med-icon-plugin.component.html",
})
export class MedIconPluginComponent extends SvgMixinComponent {}
